export default __webpack_public_path__ + "static/media/logoipsum-logo-14.f106c737.svg";